// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Routes, Route } from 'react-router-dom';
import Signup from './Signup';
import Cashier from './Cashier';
import Native from './Native';

export function App() {
  return (
    <Routes>
      <Route path='/' element={ <Signup /> } />
      <Route path='/cashier/:auth_code' element={ <Cashier /> } />
      <Route path='/native/:authcode' element={ <Native /> } />
    </Routes>
  )
}

export default App;

if (import.meta.vitest) {
  const { it, expect, beforeEach } = import.meta.vitest;
  let render: any;
  let MemoryRouter: any;

  beforeEach(async () => {
    render = (await import('@testing-library/react')).render;
    MemoryRouter = (await import('react-router-dom')).MemoryRouter;
  });

  it('should render successfully', () => {
    const { baseElement } = render(
      <MemoryRouter>
        <App />
      </MemoryRouter>
    );
    expect(baseElement).toBeTruthy();
  });
}
